const TONES = {
	neutral: 'bg-slate-100 text-slate-700',
	success: 'bg-emerald-100 text-emerald-800',
	warning: 'bg-amber-100 text-amber-800',
	danger: 'bg-red-100 text-red-800',
	info: 'bg-sky-100 text-sky-800',
} as const

export type Tone = keyof typeof TONES

// Status vocabularies from the backend, mapped to a tone once so every table
// renders the same word the same colour.
const STATUS_TONES: Record<string, Tone> = {
	active: 'success',
	in_trial: 'info',
	pending: 'warning',
	cancelling: 'warning',
	non_renewing: 'warning',
	cancelled: 'danger',
	failed: 'danger',
	success: 'success',
	failure: 'danger',
	admin: 'info',
	user: 'neutral',
	system: 'warning',
}

export function toneFor(value: string): Tone {
	return STATUS_TONES[value] ?? 'neutral'
}

export function Badge({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: Tone }) {
	return (
		<span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${TONES[tone]}`}>
			{children}
		</span>
	)
}

export function StatusBadge({ value }: { value: string }) {
	return <Badge tone={toneFor(value)}>{value.replace(/_/g, ' ')}</Badge>
}
